import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Container from '../../node_modules/reactstrap/esm/Container.js';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme/index.js';
import { openThankyouViewAnim } from './animations.js';

var _templateObject, _templateObject2, _templateObject3;
var _Theme$fonts = Theme.fonts,
  PlayfairDisplay = _Theme$fonts.PlayfairDisplay,
  Montserrat = _Theme$fonts.Montserrat;
var _Theme$colors = Theme.colors,
  primary = _Theme$colors.primary,
  blueGrey = _Theme$colors.blueGrey;
var Wrapper = styled(Container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  opacity: 0;\n  text-align: center;\n\n  ", "\n"])), Montserrat, blueGrey, function (props) {
  return props.open && openThankyouViewAnim;
});
var Heading = styled.h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n"])), primary, PlayfairDisplay);
var Subheading = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 0.75rem;\n  font-weight: 400;\n"])), blueGrey);
var ThankyouView = function ThankyouView(_ref) {
  var open = _ref.open;
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    open: open
  }, /*#__PURE__*/React__default.createElement(Heading, null, "Thank you!"), /*#__PURE__*/React__default.createElement(Subheading, null, "We appreciate your feedback."));
};
ThankyouView.propTypes = {
  open: PropTypes.bool
};

export { ThankyouView as default };
